import React, { Component } from "react";
import { Button, Dialog, DialogActions } from "@material-ui/core";
import { TimePicker } from "material-ui-time-picker";
import moment from "moment";
import { styled, ThemeProvider, createTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { GlobalStyles } from "@mui/system";

const StyledTextField = styled(TextField)({
  margin: "5px",
  width: "128px",
  "& .MuiInputBase-root": {
    backgroundColor: "#e3f1fe",
    borderRadius: "6px",
    paddingRight: "4px",
    cursor: "pointer",
  },
});

const customTheme = createTheme({
  components: {
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: "10px",
          overflow: "hidden",
        },
      },
    },
  },
});

const clockClasses = {
  circle: "myClockCircle",
  number: "myClockNumber",
  pointer: "myClockPointerPointer",
  thumb: "myClockPointerThumb",
};

const GlobalClockStyles = () => (
  <GlobalStyles
    styles={{
      '[class*="Clock-container"]': { backgroundColor: "#edecec !important" },
      '[class*="Clock-circle"]': { backgroundColor: "#edecec !important" },
      '[class*="ClockNumber"]': { color: "#000 !important" },
      '[class*="ClockPointer-thumb"]': { backgroundColor: "#1976d2 !important" },
      '[class*="ClockPointer-pointer"]': { backgroundColor: "#1976d2 !important" },
      ".MuiDialog-paper": { backgroundColor: "#edecec !important" },
      ".myClockCircle": { backgroundColor: "#edecec !important" },
      ".myClockNumber": { color: "#000 !important" },
      ".myClockPointerThumb": { backgroundColor: "#1976d2 !important" },
      ".myClockPointerPointer": { backgroundColor: "#1976d2 !important" },
    }}
  />
);

const ClockWrapper = styled("div")({
  "& [class*='Clock-circle']": { backgroundColor: "#edecec !important" },
  "& [class*='ClockNumber']": { color: "#000 !important" },
});

class SimpleTimePicker extends Component {
  TIME_FORMAT = "HH:mm";

  constructor(props) {
    super(props);
    this.state = {
      dialogIsOpen: false,
      selectedValue: this.props.defaultValue
        ? moment(this.props.defaultValue, this.TIME_FORMAT)
        : null,
    };
  }

  openDialog = () => {
    this.setState({ dialogIsOpen: true });
  };

  closeDialog = (isOk = false) => {
    if (isOk && this.props.value) {
      const finalValue =
        this.state.selectedValue && moment.isMoment(this.state.selectedValue)
          ? this.state.selectedValue
          : moment();

      const adjusted = this.adjustTimeInBounds(finalValue);

      this.props.value(adjusted);

      this.setState({
        selectedValue: adjusted,
        dialogIsOpen: false,
      });
    } else {
      this.setState({ dialogIsOpen: false });
    }
  };

  adjustTimeInBounds = (newValue) => {
    if (!newValue) return undefined;
    const momentValue = moment(newValue);

    if (this.props.minDateTime && momentValue.isBefore(this.props.minDateTime))
      return this.props.minDateTime;

    if (this.props.maxDateTime && momentValue.isAfter(this.props.maxDateTime))
      return this.props.maxDateTime;

    return momentValue;
  };

  handleDialogTimeChange = (newValue) => {
    this.setState({
      selectedValue: this.adjustTimeInBounds(moment(newValue)),
    });
  };

  render() {
    const displayValue = this.state.selectedValue
      ? this.state.selectedValue.format(this.TIME_FORMAT)
      : "";

    return (
      <ThemeProvider theme={customTheme}>
        <GlobalClockStyles />
        <ClockWrapper>
          <span>
            <StyledTextField
              variant="outlined"
              size="small"
              value={displayValue}
              InputProps={{ readOnly: true }}
              onClick={this.openDialog}
            />

            <Dialog maxWidth="xs" open={this.state.dialogIsOpen}>
              <TimePicker
                mode="24h"
                value={
                  this.state.selectedValue
                    ? this.state.selectedValue.toDate()
                    : new Date()
                }
                onChange={this.handleDialogTimeChange}
                classes={clockClasses} 
              />
              <DialogActions>
                <Button
                  onClick={() => this.closeDialog(false)}
                  color="primary"
                >
                  Cancel
                </Button>
                <Button onClick={() => this.closeDialog(true)} color="primary">
                  Ok
                </Button>
              </DialogActions>
            </Dialog>
          </span>
        </ClockWrapper>
      </ThemeProvider>
    );
  }
}

export default SimpleTimePicker;